import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import { MonthlyCalendarCell } from 'components/Calendar'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getActiveDates, getClosedDates, getSpecialHolidays } from 'reducks/calendar/selectors'
import { getOrders } from 'reducks/checkout/selectors'
import { dateToString, parseToDate } from 'lib/helper'
import { OrderType } from 'types/checkout'
import { SpecialHolidayType } from 'types/calendar'

type Props = {
  isDeliveryCalendar: boolean
  row: Date[]
}

const MonthlyCalendarRow: FC<Props> = (props) => {
  const { isDeliveryCalendar, row } = props

  const activeDates = useSelector((state: State) => getActiveDates(state))
  const closedDates = useSelector((state: State) => getClosedDates(state))
  const orders: OrderType[] = useSelector((state: State) => getOrders(state))
  const specialHolidays: SpecialHolidayType[] = useSelector((state: State) => getSpecialHolidays(state))

  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isActive = activeDates.some((activeDate) => isSameDay(activeDate, date))
        const isClosed = isDeliveryCalendar ? false : closedDates.some((disabledDate) => isSameDay(disabledDate, date))
        const isOrdered = orders.some((order) => isSameDay(parseToDate(order.date), date))
        const isSpecialHoliday = specialHolidays.some((specialHoliday) => specialHoliday.date === dateToString(date))

        return (
          <MonthlyCalendarCell
            key={getDate(date)}
            date={date}
            isActive={isActive}
            isClosed={isClosed}
            isOrdered={isOrdered}
            isSpecialHoliday={isSpecialHoliday}
          />
        )
      })}
    </tr>
  )
}

export default MonthlyCalendarRow
